"use client";

import { useCallback } from "react";
import { useSelector } from "react-redux";

import RichText from "@/components/atoms/rich-text/rich-text";
import withApplication from "@/components/with-application";
import { RenewalPage } from "@/config/app-constant";
import {
  BASIC,
  COMPREHENSIVE,
  SIGNATURE,
  ESSENTIALS,
  CLASSIC,
  DELUXE,
} from "@/constants";
import { RootState } from "@/store/root-reducer";

import Style from "./review-section.module.css";

type BeforeContinueProps = {
  beforeContinueTitle: string;
  beforeContinueSubTitle: string;
  beforeContinueContentBasic: string;
  beforeContinueContentComprehensive: string;
  beforeContinueMedicalMessage: string;
  beforeContinueContentSignature: string;
  beforeContinueContentEssentials: string;
  beforeContinueContentClassic: string;
  beforeContinueContentDeluxe: string;
  beforeContinueContentCruiseClassic: string;
  beforeContinueContentCruiseDeluxe: string;
  beforeContinueMainTitle?: string;
  application?: string;
};

function BeforeContinue({
  beforeContinueTitle,
  beforeContinueSubTitle,
  beforeContinueContentBasic,
  beforeContinueContentComprehensive,
  beforeContinueContentEssentials,
  beforeContinueContentClassic,
  beforeContinueContentDeluxe,
  beforeContinueContentCruiseClassic,
  beforeContinueContentCruiseDeluxe,
  beforeContinueContentSignature,
  beforeContinueMedicalMessage,
  beforeContinueMainTitle,
  application,
}: Readonly<BeforeContinueProps>) {
  const quoteData = useSelector((state: RootState) => state.quote);
  const { attributes } = quoteData;
  const { tripDetails, travellerDetails } = attributes;

  const replacePolicyDocLink = useCallback(
    (text: string) => {
      return text?.replace(
        "https://[Policy_Document_Link]",
        (quoteData?.attributes?.dynamicDocuments?.documentUrls
          ?.POLICY_WORDING as string) ?? ""
      );
    },
    [quoteData]
  );

  const getRichTextContent = () => {
    // AVANTI CRUISE
    if (tripDetails?.product === "CRUISE") {
      switch (tripDetails?.policyPackage) {
        case CLASSIC:
          return replacePolicyDocLink(beforeContinueContentCruiseClassic);
        case DELUXE:
          return replacePolicyDocLink(beforeContinueContentCruiseDeluxe);
        default:
          return "";
      }
    }

    switch (tripDetails?.policyPackage) {
      // STAYSURE
      case BASIC:
        return replacePolicyDocLink(beforeContinueContentBasic);
      case COMPREHENSIVE:
        return replacePolicyDocLink(beforeContinueContentComprehensive);
      case SIGNATURE:
        return replacePolicyDocLink(beforeContinueContentSignature);

      // AVANTI
      case ESSENTIALS:
        return replacePolicyDocLink(beforeContinueContentEssentials);
      case CLASSIC:
        return replacePolicyDocLink(beforeContinueContentClassic);
      case DELUXE:
        return replacePolicyDocLink(beforeContinueContentDeluxe);
      default:
        return "";
    }
  };
  return (
    <main className="BeforeContinue  ">
      <div className=" font-body-font ">
        {application === RenewalPage && beforeContinueMainTitle && (
          <h1 className="text-text-title font-header-font font-[400] text-xl md:text-5xl md:leading-[45px] leading-custom-size-l/xl text-left mb-spacing-m md:mb-spacing-l">
            {beforeContinueMainTitle}
          </h1>
        )}
        <div
          className={`font-header-font md:text-[25px] ${
            application === RenewalPage
              ? "text-s leading- [21px]"
              : "text-[23px] leading-[27.6px]"
          }
          md:leading-[27.5px] text-text-title ${
            beforeContinueTitle && "mb-spacing-xs"
          } md:text-left`}
        >
          {beforeContinueTitle}
        </div>
        <div
          className={`leading-[27px] text-[18px] font-semibold ${
            beforeContinueSubTitle && "mb-spacing-xs"
          }  font-body-font`}
        >
          {beforeContinueSubTitle}
        </div>
        <div className={`${Style.list_block}`}>
          <RichText
            richText={getRichTextContent()}
            className={`${
              application === RenewalPage && "[&_li]:ml-spacing-xs"
            }`}
            data-testid="richText-testid"
          />
          {travellerDetails?.showMoneyHelperMessage && (
            <div className="mt-spacing-m">
              <RichText
                richText={beforeContinueMedicalMessage}
                data-testid="richText-testid"
              />
            </div>
          )}
        </div>
      </div>
    </main>
  );
}

export default withApplication(BeforeContinue);
